export enum ImportFileType {
  IMPORT_MACHINES = 'IMPORT_MACHINES'
}
